<template>
  <v-container fluid grid-list-md v-if="plan !== null && plan !== undefined">
    <v-layout row wrap>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="medical_services"
        :value="$t('components.claims_history.tab.submitted')"
        v-if="role.indexOf('Claims Administrator') > -1"
      >
        <template slot="actions">
          <div class="d-flex justify-center">
            <v-btn
              text
              color="primary"
              @click="$router.push({ name: 'claimsTable' })"
            >
              {{
                $t(
                  "views.members.manage"
                )
              }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
      :color="$vuetify.theme.themes.light.secondary"
        icon="medical_services"
        :value="$t('components.vuematerialdashboard.core.appbar.claims_payments')"
        v-if="role.indexOf('Claims Administrator') > -1"
      >
        <template slot="actions">
          <div class="d-flex justify-center">
            <v-btn
              text
              color="primary"
              @click="$router.push({ name: 'claimsPayments' })"
            >
              {{
                $t(
                  "globals.view"
                )
              }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$router.push({ name: 'claimsReports' })"
            >
              {{
                $t(
                  "views.billing.archive"
                )
              }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {};
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
    ...mapGetters("common", ["messages"]),
  },
  methods: {},
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
